import React, { useMemo } from 'react';
import { DialogComponent, Spinner } from '../../../../../Components';
import ContactAndLeadInfo from '../../../../../Components/CreateLeadDialog/components/ContactAndLeadInfo';
import useFetchData from '../../../../../Hooks/useFetchData';
import { showError } from '../../../../../Helper';
import LinkToOfferDialogBody from './LinkToOfferDialogBody';
import { GetContactById } from '../../../../../Services';

const LinkToOfferDialog = ({
  open,
  onClose,
  contactId,
  clientEmail,
  clientPhone,
  contactName,
}) => {
  const {
    data: contact,
    loading,
    isError,
  } = useFetchData(GetContactById, contactId);

  const contactDetails = useMemo(
    () => (contact?.contactJson ? JSON.parse(contact.contactJson) : null),

    [contact]
  );
  if (loading || !contactDetails) return <Spinner isActive isAbsolute />;
  if (isError) {
    showError('failed to fetch contact details');
    return null;
  }
  return (
    <DialogComponent
      titleText={'Link to offer'}
      isOpen={open}
      onCloseClicked={onClose}
      dialogContent={
        <div>
          <ContactAndLeadInfo contact={contactDetails} />
          <LinkToOfferDialogBody
            onClose={onClose}
            fullName={contactName}
            email={clientEmail}
            phoneNumber={clientPhone}
          />
        </div>
      }
    />
  );
};
export default LinkToOfferDialog;
